<template>
  <div class="tools02-tag-fire-tag-fire-editor">
    <el-row>
      <el-col :span="4">
        <a :href="toolData.manualData.tagFireManualUrl" target="_blank" rel="noopener noreferrer">
          <Button2 type2="1" class="manual-button" msg="マニュアル" />
        </a>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="18">
        <table class="typeB">
          <tr>
            <th>
              <span>{{ g_getTools02TagCategoryName(toolId) }}名</span>
            </th>
            <td>{{ tagData.name }}</td>
          </tr>
          <tr>
            <th>
              <span>
                <span v-if="
                  tool.codeKebab === 'facebook-cv' ||
                  tool.codeKebab === 'tiktok-cv'
                ">ピクセルID</span>
                <span v-else-if="tool.codeKebab === 'line-cv'">LINE Tag ID</span>
                <span v-else-if="tool.codeKebab === 'yda-cv'">yahoo_ydn_conv_io</span>
              </span>
            </th>
            <td>{{ tagData.mediaTagId }}</td>
          </tr>
          <tr v-if="toolData.codeKebab === 'tiktok-cv'">
            <th>
              <span>CVイベント</span>
            </th>
            <td>
              <el-select v-model="tiktokEvent" placeholder="選択してください。" style="width: 340px">
                <el-option v-for="(tiktokEventData, index) in tiktokEventList" :key="index"
                  :label="tiktokEventData.name + `（${tiktokEventData.event}）`"
                  :value="tiktokEventData.event"></el-option>
              </el-select>
            </td>
          </tr>
          <tr v-if="toolData.codeKebab === 'line-cv'">
            <th>
              <span>CVイベント</span>
            </th>
            <td>
              <el-select v-model="lineEvent" placeholder="選択してください。" style="width: 340px">
                <el-option v-for="(lineEventData, index) in lineEventList" :key="index"
                  :label="lineEventData.name + `（${lineEventData.event}）`" :value="lineEventData.event"></el-option>
              </el-select>
              <div v-if="lineEvent === 'CustomEvent'" style="margin-top: 10px;">
                <el-input v-model="customEventValue" placeholder="カスタムイベント名を入力してください" style="width: 340px"></el-input>
              </div>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col>
        <div class="button-cover">
          <el-button @click="fire" type="warning">発火</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button2 from "@/components/Ui/Button2.vue";

export default {
  name: "Tools02TagFireTagFireEditor",
  components: {
    Button2,
  },
  props: {
    toolId: String,
    accountId: String,
    tagId: String,
  },
  data() {
    return {
      tagData: {
        name: "",
        mediaTagId: "",
        accessToken: "",
        testCode: "",
      },

      //
      tiktokEvent: "",
      lineEvent: "Conversion",
      customEventValue: "",
    };
  },
  computed: {
    ...mapGetters(["rt", "tool"]),
    ...mapGetters("tools02", ["tiktokEventList", "lineEventList"]),
    toolData() {
      return this.$store.getters["toolData"](this.toolId);
    },
  },
  watch: {
    tagId: {
      handler(newTagId) {
        this.tagData = JSON.parse(
          JSON.stringify(
            this.$store.getters["tools02/tagData"](this.toolId, newTagId)
          )
        );
      },
      immediate: true,
    },
  },
  methods: {
    fire() {
      // 
      let eventName = "";
      if (this.toolData.codeKebab === 'tiktok-cv') {
        eventName = this.tiktokEvent;
      } else if (this.toolData.codeKebab === 'line-cv') {
        // 
        if (
          this.lineEvent !== '' &&
          this.lineEvent !== null
        ) {
          // no action.
        } else {
          alert("「CVイベント」を選択してください。");
          return;
        }
        // 
        eventName = this.lineEvent;

        // 
        if (this.lineEvent === 'CustomEvent') {
          if (this.customEventValue !== '' && this.customEventValue !== null) {
            eventName = this.customEventValue;
          } else {
            alert("カスタムイベント名を入力してください。");
            return;
          }
        } else {
          // no action.
        }
      } else {
        alert("未対応のツールです。");
        return;
      }

      // 
      window.open(`${this.rt}/tests/tools02/media/${this.toolData.codeKebab}/pixel-fire.php?id=${this.tagData.mediaTagId}&event=${eventName}`, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.button-cover {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    margin: 0 20px;
  }
}
</style>
